module.exports = __webpack_public_path__ + "img/avatar.7495a1be.png";